import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ModalModule } from "@modules/app-modal/modal.module";
import { TranslationPipeModule } from "@modules/core/pipes/translation-pipe/translation-pipe.module";
import { FiatPrecisionPipeModule } from "@modules/+new/shared/fiat-precision-pipe/fiat-precision-pipe.module";
import { FiatSymbolPipeModule } from "@modules/+new/shared/fiat-symbol-pipe/fiat-symbol-pipe.module";
import { SummaryGridModule } from "@modules/+new/payments/shared-payments/components/summary-grid/summary-grid.module";
import { SummaryCommonComponent } from "@modules/+new/payments/shared-payments/components/summary-common/summary-common.component";

@NgModule({
	declarations: [SummaryCommonComponent],
	exports: [SummaryCommonComponent],
	imports: [
		CommonModule,
		ModalModule,
		TranslationPipeModule,
		SummaryGridModule,
		FiatPrecisionPipeModule,
		FiatSymbolPipeModule
	]
})
export class SummaryCommonModule {}
